// Styled Modal с повышенным z-index
import styled, {keyframes} from "styled-components";
import {Modal} from "@consta/uikit/Modal";
import {SnackBarItemStatus} from "@consta/uikit/SnackBar";
import {Button} from "@consta/uikit/Button";

export const StyledModal = styled(Modal)`
    z-index: 9999 !important;

    .Modal-Overlay {
        z-index: 9998 !important;
    }

    .Modal-Window {
        z-index: 9999 !important;
    }
`;


// Styled Components
export const ModalContainer = styled.div`
    padding: 24px;
    background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
    border-radius: 12px;
    min-height: 400px;
    position: relative;
    z-index: 1000;
`;

export const ModalHeader = styled.div`
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid #e2e8f0;
`;

export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #1a202c;
    display: flex;
    align-items: center;
    gap: 12px;

    &:before {
        content: '📁';
        font-size: 28px;
    }
`;

export const ModalSubtitle = styled.p`
    margin: 8px 0 0 0;
    font-size: 14px;
    color: #718096;
`;

export const FileCard = styled.div`
    background: white;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    border: 1px solid #e2e8f0;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
    }
`;

export const ProgressBarContainer = styled.div`
    margin: 24px 0;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const ProgressBarWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 8px;
    background: #e2e8f0;
    border-radius: 4px;
    overflow: hidden;
`;

export const shimmer = keyframes`
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
`;

export const ProgressBarFill = styled.div<{ progress: number }>`
    height: 100%;
    width: ${props => props.progress}%;
    background: linear-gradient(90deg, #4299e1 0%, #3182ce 50%, #2c5282 100%);
    background-size: 200% 100%;
    animation: ${shimmer} 2s infinite;
    border-radius: 4px;
    transition: width 0.3s ease;
`;

export const ProgressText = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    font-size: 14px;
    color: #4a5568;
    font-weight: 500;
`;

export const ProgressLabel = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;

    &:before {
        content: '⚙️';
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

export const FileStatus = styled.div<{ status: 'pending' | 'processing' | 'success' | 'error' }>`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    margin-top: 8px;

    ${props => {
        switch (props.status) {
            case 'pending':
                return `
                    background: #edf2f7;
                    color: #4a5568;
                `;
            case 'processing':
                return `
                    background: #bee3f8;
                    color: #2c5282;
                `;
            case 'success':
                return `
                    background: #c6f6d5;
                    color: #22543d;
                `;
            case 'error':
                return `
                    background: #fed7d7;
                    color: #742a2a;
                `;
        }
    }}
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e2e8f0;
`;

export const StyledButton = styled(Button)`
    &.cancel {
        margin-left: 8px;
    }
`;
